 (function () {
   const section = document.getElementById('custom-wst-parallax-products-{{ section.id }}');
   if (!section) return;

   const items = section.querySelectorAll('.custom-wst-parallax-item');
   const total = items.length;

   const foldHeight = window.innerHeight * 0.8;

    //Set section height dynamically
   section.style.height = `${total * foldHeight}px`;

   function updateParallax() {
     const rect = section.getBoundingClientRect();
     const scrollY = window.innerHeight - rect.top;
     const index = Math.floor(scrollY / foldHeight);

     items.forEach((item, i) => {
       item.classList.toggle('is-active', i === index);
     });
   }

   window.addEventListener('scroll', updateParallax);
   window.addEventListener('load', updateParallax);
 })();



 gsap.set([
   ".image-banner__inner-heading",
   ".image-banner__inner-link",
   ".image-banner__inner-text"
 ], {
   opacity: 1,
   x: 0,
   y: 0
 });


 gsap.registerPlugin(ScrollTrigger);

 const tl = gsap.timeline({
   scrollTrigger: {
   trigger: "#cinematic-stage",
      start: "top top",
     end: "+=220%",
     scrub: true,
     pin: true,
     anticipatePin: 1
   }
 });

/* === HERO BACKGROUND PUSH === */
 tl.to("#cinematic-hero", {
   scale: 0.82,
   opacity: 0,
   ease: "none"
 }, 0);



/* IMAGE DEPTH */
tl.to("#cinematic-hero .image-banner__image", {
  scale: 1.25,
  ease: "none"
}, 0);

/* BACKGROUND DIM */
// tl.to("#cinematic-hero::after", {
//   opacity: 0.6,
//   ease: "none"
// }, 0.1);

/* === TEXT EXIT (VIDEO STYLE) === */

/* === TEXT EXIT (VIDEO STYLE) === */
tl.to(".image-banner__inner-heading", {
  y: -80,
  opacity: 1,
  ease: "none"
}, 0.25); // ⬅️ delayed

tl.to(".image-banner__inner-link", {
  y: 60,
  opacity: 1,
  ease: "none"
}, 0.28);

tl.to(".image-banner__inner-text", {
  x: 60,
  opacity: 1,
  ease: "none"
}, 0.3);




/* === SECTION 2 REVEAL === */
tl.to("#cinematic-reveal", {
  scale: 1,
  opacity: 1,
  ease: "none"
}, 0.3);

/* === HARD KILL HERO (IMPORTANT) === */
tl.set("#cinematic-hero", {
  visibility: "hidden",
  pointerEvents: "none"
}, 0.6);

document.querySelectorAll('.read-more-btn').forEach((btn) => {
  const strength = 30; // magnetic intensity
  const resetEase = 'power3.out';

  let bounds;

  function updateBounds() {
    bounds = btn.getBoundingClientRect();
  }

  updateBounds();
  window.addEventListener('resize', updateBounds);

  btn.addEventListener('mousemove', (e) => {
    const x = e.clientX - bounds.left - bounds.width / 2;
    const y = e.clientY - bounds.top - bounds.height / 2;

    gsap.to(btn, {
      x: x / strength,
      y: y / strength,
      rotateX: (-y / 10),
      rotateY: (x / 10),
      duration: 0.3,
      ease: 'power3.out'
    });
  });

  btn.addEventListener('mouseenter', () => {
    gsap.to(btn.querySelector('.circle-fill'), {
      scale: 1,
      duration: 0.55,
      ease: 'power3.out'
    });

    gsap.to(btn.querySelector('.circle-text'), {
      opacity: 1,
      duration: 0.25,
      ease: 'power2.out'
    });
  });

  btn.addEventListener('mouseleave', () => {
    gsap.to(btn, {
      x: 0,
      y: 0,
      rotateX: 0,
      rotateY: 0,
      duration: 0.6,
      ease: resetEase
    });

    gsap.to(btn.querySelector('.circle-fill'), {
      scale: 0,
      duration: 0.45,
      ease: 'power3.inOut'
    });

    gsap.to(btn.querySelector('.circle-text'), {
      opacity: 0,
      duration: 0.2,
      ease: 'power2.in'
    });
  });
});